import type { NewsArticle } from '@/types';

export const news: NewsArticle[] = [
  {
    id: 'nw-01',
    title: '科幻新片《星海远征》定档：一次关于时间与归途的远征',
    summary: '这部筹备四年的科幻电影正式宣布上映档期，制作团队首次公开了深空探测队的设定集与幕后故事。',
    author: '河马AV 编辑部',
    date: '2026-10-08',
    topic: '新片动态',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20spacecraft%20model%20on%20a%20dark%20studio%20table%20with%20deep%20blue%20lighting%20and%20warm%20accent%20highlights%20professional%20film%20press%20imagery%20soft%20shadows%20high%20detail&width=800&height=450&seq=hema-nw-01&orientation=landscape',
    content: `备受期待的科幻电影《星海远征》今日正式公布上映档期，影片将同步登陆院线与部分海外市场。作为导演陆云舟的第四部长片，该片筹备期长达四年，从概念设计到实体道具，都保留了大量手工制作的痕迹。

在最新发布的幕后特辑中，制作团队首次公开了影片中探测舰的完整设定。工作人员介绍，团队为舰体内部搭建了近乎一比一的可拍摄实景，仅主控舱的仪表就超过两百个独立可动的部件。

导演陆云舟在采访中表示，这部电影表面上是关于深空探索，内核其实更接近一封写给归途的信。“我们想讨论的不是我们能走多远，而是无论走多远，我们还记得为什么要回去。”

主演程亦南透露，为了呈现失重状态下的真实感，演员们提前接受了长达六周的训练。影片将于下月起陆续开启点映场次。`,
  },
  {
    id: 'nw-02',
    title: '剧集《长安旧梦》口碑走高：古装悬疑的另一种打开方式',
    summary: '开播两周，这部古装悬疑剧凭借扎实的考据与细腻的人物塑造，成为近期讨论度最高的剧集之一。',
    author: '河马AV 编辑部',
    date: '2026-10-05',
    topic: '剧集观察',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20warm%20chinese%20lanterns%20glowing%20in%20an%20ancient%20street%20at%20dusk%20deep%20blue%20evening%20tones%20with%20amber%20accents%20professional%20editorial%20composition%20high%20detail&width=800&height=450&seq=hema-nw-02&orientation=landscape',
    content: `开播两周，《长安旧梦》的评分与讨论度持续走高。与许多追求快节奏反转的悬疑剧不同，这部剧选择用大量篇幅去描绘人物所处的日常——灯会、市集、书斋，让案件自然生长在生活之中。

编剧团队透露，为了还原盛唐的城市质感，剧组查阅了大量文献与图册，从灯笼的样式到街市的叫卖，都做了细致的功课。“我们不想让观众觉得这是搭出来的布景，而是相信真的有这样一条街。”

不少观众表示，真正打动他们的是剧中人物的选择。女尚书苏莞与画师裴远联手查案的过程，也是两个人各自与过去和解的过程。这种“慢”在一众悬疑剧中显得格外难得。

目前该剧已更新过半，后续走向仍留有悬念。`,
  },
  {
    id: 'nw-03',
    title: '纪录片《大地脉动》收官：四年拍摄，横跨六大地理带',
    summary: '这部自然纪录片的收官集上线，摄制组分享了四年拍摄中的艰辛与惊喜。',
    author: '河马AV 编辑部',
    date: '2026-10-02',
    topic: '纪录片',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20aerial%20editorial%20photograph%20of%20misty%20mountain%20ranges%20and%20a%20winding%20river%20at%20dawn%20deep%20blue%20tones%20with%20warm%20amber%20light%20professional%20nature%20documentary%20style%20high%20detail&width=800&height=450&seq=hema-nw-03&orientation=landscape',
    content: `历时四年的自然纪录片《大地脉动》正式收官。摄制组横跨六大地理带，用镜头记录山川、河流与湿地在季节中的变化。

总导演在收官访谈中提到，最难的不是拍摄本身，而是等待。“有些画面我们等了整整两个月，只为三秒钟的光影。但当你亲眼看到的时候，会觉得一切都值得。”

影片的解说由程亦南担任。他表示，自己在录制时特意放慢了语速，“因为画面本身已经足够有力量，不需要太多语言去填满它。”

制作方表示，未来还计划推出相关的幕后纪实与影像图集，让观众看到镜头之外的更多故事。`,
  },
  {
    id: 'nw-04',
    title: '行业观察：短剧与长剧开始互相“取经”',
    summary: '当短剧的节奏遇上长剧的深度，两种形态正在相互学习，观众也迎来了更丰富的选择。',
    author: '特约评论员 江叙',
    date: '2026-09-28',
    topic: '行业观察',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20film%20editing%20timeline%20on%20a%20large%20screen%20in%20a%20dark%20studio%20deep%20blue%20lighting%20with%20warm%20amber%20accents%20professional%20media%20workspace%20high%20detail&width=800&height=450&seq=hema-nw-04&orientation=landscape',
    content: `近一年来，短剧与长剧之间的边界正在变得模糊。一方面，短剧开始尝试更完整的人物弧线与更耐心的叙事；另一方面，长剧也在借鉴短剧对节奏与信息密度的处理。

一位从业多年的制片人认为，这种互相“取经”是好事。“观众的注意力是有限的，无论哪种形态，都要回答同一个问题：为什么值得看下去。”

也有评论指出，形态的融合不应以牺牲质量为代价。真正决定作品生命力的，仍是故事与人物本身，而不是时长。

可以预见，随着创作与技术的成熟，观众将拥有更加多元、也更讲究的选择。`,
  },
  {
    id: 'nw-05',
    title: '《深蓝档案》确认续订：第二季将深入海底世界',
    summary: '这部科幻悬疑剧在首季收官后不久即确认续订，主创团队透露第二季的规模将全面升级。',
    author: '河马AV 编辑部',
    date: '2026-09-24',
    topic: '新片动态',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20glowing%20underwater%20server%20corridor%20with%20deep%20ocean%20blue%20light%20and%20warm%20amber%20accents%20professional%20sci%20fi%20press%20imagery%20high%20detail&width=800&height=450&seq=hema-nw-05&orientation=landscape',
    content: `科幻悬疑剧《深蓝档案》在首季收官后不久便确认续订。主创团队表示，第一季留下的悬念将在第二季得到回应，同时也会提出新的问题。

制作人透露，第二季将把更多镜头交给海底世界本身。“我们想让它不只是一个背景，而是一个有性格、有呼吸的角色。”

主演艾拉·诺曼在社交媒体上感谢观众的支持，并透露自己已经开始为新一季的体能训练做准备。

目前第二季已进入前期筹备阶段，预计将于明年进入正式拍摄。`,
  },
  {
    id: 'nw-06',
    title: '国漫新番集中上线，题材从科幻到奇幻全面开花',
    summary: '本季度多部原创国漫同期上线，题材覆盖科幻、奇幻与现实主义，展现出国产动画的多元可能。',
    author: '河马AV 编辑部',
    date: '2026-09-20',
    topic: '国漫动态',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20colorful%20animation%20concept%20art%20boards%20pinned%20on%20a%20studio%20wall%20deep%20blue%20ambient%20light%20with%20warm%20amber%20accents%20professional%20creative%20workspace%20high%20detail&width=800&height=450&seq=hema-nw-06&orientation=landscape',
    content: `本季度有多部原创国产动画集中上线，题材从科幻、奇幻到现实主义生活，呈现出愈发多元的面貌。

与以往改编为主不同，这一批新番中原创作品占了相当比例。多位创作者表示，观众的口味正在变得更加开放，这给了原创更大的空间。

《机械之心》的导演在采访中提到，团队花了大量时间打磨机器人的“表情”。“它没有五官，但观众要能读懂它的情绪，这需要靠姿态和光影去完成。”

随着制作水平的提升，国产动画正在被更多不同年龄层的观众接受。`,
  },
  {
    id: 'nw-07',
    title: '观察：观众为什么越来越在意“幕后”',
    summary: '从制作特辑到创作者访谈，幕后内容的受欢迎程度持续上升，背后是观众与作品关系的变化。',
    author: '特约评论员 江叙',
    date: '2026-09-15',
    topic: '行业观察',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20behind%20the%20scenes%20camera%20rig%20on%20a%20film%20set%20at%20night%20deep%20blue%20lighting%20with%20warm%20amber%20accents%20professional%20documentary%20style%20high%20detail&width=800&height=450&seq=hema-nw-07&orientation=landscape',
    content: `越来越多的观众在看完一部作品后，会主动去寻找它的幕后内容：制作特辑、创作者访谈、概念设计图。

一种解释是，观众与作品之间的关系正在从“消费”走向“陪伴”。了解一部作品如何被创造出来，会让观看本身变得更加完整。

对创作者而言，这也意味着更高的透明度与更直接的沟通。一位导演坦言，他会在意观众对幕后内容的反馈，“因为它让我知道，大家真正在意的是什么。”

可以预见，幕后内容将不再只是附加品，而会成为作品体验的一部分。`,
  },
  {
    id: 'nw-08',
    title: '《归途》主创谈创作：我们想拍一条普通的路',
    summary: '这部公路题材剧集用一条回乡的路，串起了一代人的记忆与情感。',
    author: '河马AV 编辑部',
    date: '2026-09-10',
    topic: '剧集观察',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20an%20empty%20highway%20stretching%20toward%20a%20distant%20town%20at%20sunset%20deep%20blue%20dusk%20tones%20with%20warm%20amber%20light%20professional%20road%20movie%20style%20high%20detail&width=800&height=450&seq=hema-nw-08&orientation=landscape',
    content: `以公路为线索的剧集《归途》正在热播。小编剧团队在采访中表示，他们想拍的其实是一条“普通的路”。

“它没有惊天动地的故事，只有一路上遇到的人，和他们在车里说的话。”编剧说，“但我们觉得，正是这些普通的东西，才最接近生活。”

主演罗子谦为了演好货车司机，特意跟车体验了半个月。他笑称，那段时间自己学会了换轮胎，也学会了在漫长的沉默里专注。

有观众评论说，看完这部剧，突然很想给家里打个电话。这大概就是对创作者最好的回应。`,
  },
  {
    id: 'nw-09',
    title: '短片《窗》入围国际影展：十四分钟讲一个“靠近”的故事',
    summary: '这部由新锐导演执导的短片入围多个国际影展，用极简的场景讲述了一个关于孤独与靠近的故事。',
    author: '河马AV 编辑部',
    date: '2026-09-04',
    topic: '影展资讯',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20single%20apartment%20window%20glowing%20warmly%20against%20a%20deep%20blue%20night%20facade%20professional%20moody%20street%20photography%20high%20detail&width=800&height=450&seq=hema-nw-09&orientation=landscape',
    content: `短片《窗》近日入围多个国际影展的短片单元，这部时长仅十四分钟的作品，用几乎单一的机位讲述了一个完整的故事。

导演卡米耶·罗表示，最初的灵感来自她居住多年的一栋公寓。“我常常看着对面的窗户想，那些人过着怎样的生活。后来我发现，我们其实都在看着别人，却很少真的走过去。”

影片几乎没有对白，全部依靠光影与表演推进。评审在评语中写道：“它用最少的东西，说出了最多的东西。”

据悉，该片后续还将在多个城市进行展映。`,
  },
];